import pure from 'recompose/pure';

export default pure;
